import React, { useEffect } from "react";
import Image_Profile from "../../assets/images/members/profile-picture.png";
import Image_NEHALKUMAR from "../../assets/images/members/DR.-NEHALKUMAR-P.-SHAH.jpg";
import Image_RAJIV_LIMBASIYA from "../../assets/images/members/DR.RAJIV-LIMBASIYA.jpg";
import Image_AMIT_PATEL from "../../assets/images/members/DR.AMIT-M-PATEL.jpg";
import Image_NIRAVKUMAR_MEHATA from "../../assets/images/members/DR.-NIRAVKUMAR-MEHTA.jpg";
import Image_HELLY_THAKKAR from "../../assets/images/members/DR.HELLY-THAKKAR.jpg";
import Image_PURSHOTTAM_PUROHIT from "../../assets/images/members/SHRI-PURSHOTTAM-PUROHIT.jpg";
import Image_DEEPAK_GANJIWALE from "../../assets/images/members/DR.DEEPAK-GANJIWALE.jpg";
import Image_SL_VAYA from "../../assets/images/members/DR.S.L.VAYA.jpg";
import Image_SUNIL_SHUKLA from "../../assets/images/members/DR.-SUNILSHUKLA.jpg";
import Image_RAKESH_RAWAL from "../../assets/images/members/DR.-RAKESH-RAWAL.jpg";
import Image_ALKA_SANGHVI from "../../assets/images/members/DR.ALKA-SANGHAVI.jpg";
import Image_JJ_DHADUK from "../../assets/images/members/DR.J.J.DHADUK.jpg";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import MapPin from "../../assets/images/map-pin.svg";
import { Link } from "react-router-dom";

const Members = () => {
    document.title = "Members | Gujarat State Allied and Healthcare Council";
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className="wrappermain">
                <div
                    className="banner-image"
                    style={{
                        backgroundImage: "url(" + Background_Member2 + ")",
                        backgroundSize: "fill",
                        backgroundPosition: "right",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        padding: "25px 0",
                    }}
                >
                    <div className="banner-inner-breadcrumb">
                        <div className="container">
                            <nav aria-label="breadcrumb">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={"/"}>
                                            Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={"/about-us"}>
                                            About Us
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Members</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <section className="members p-t-60 p-b-60">
                    <div className="container">
                        <h2 className="section-title text-center">Members</h2>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_NEHALKUMAR} className="img-fluid" alt="Dr. Nehalkumar P. Shah" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. Nehal P. Shah (PT)</h3>
                                        <span>Chairperson</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Divya Physiotherapy Clinic, Naroda, Ahmedabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_Profile} className="img-fluid" alt="Additional Director of Medical Education" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Additional Director of Medical Education</h3>
                                        <span>Ex officio Member</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Block No.-4, Dr.Jivraj Mehta Bhavan, Gandhinagar</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_Profile} className="img-fluid" alt="Dean" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dean, B.J.Medical College</h3>
                                        <span>Ex officio Member</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Civil hospital Campus, Asarwa, Ahmedabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_Profile} className="img-fluid" alt="Dean" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dean, Government Medical College</h3>
                                        <span>Ex officio Member</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>S.S.G.Hospital, Baroda</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_RAJIV_LIMBASIYA} className="img-fluid" alt="Dr.Rajiv Limbasiya (PT)" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr.Rajiv Limbasiya (PT)</h3>
                                        <span>Member-Physiotherapy</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Principal, Sarvajanik College of Physiotherapy, Surat</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_AMIT_PATEL} className="img-fluid" alt="Dr. Amit Patel (PT)" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. Amit Patel (PT)</h3>
                                        <span>Member-Physiotherapy</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Sr. Lecturer & PG Guide, J. G. College of Physiotherapy, Ahmedabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_NIRAVKUMAR_MEHATA} className="img-fluid" alt="Dr. Niravkumar Mehta" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. Niravkumar Mehta</h3>
                                        <span>Member-Optometry</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Principal, Hari Jyot College of Optometry, Navsari</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_HELLY_THAKKAR} className="img-fluid" alt="Dr. Helly Krushang Thakkar" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. Helly Krushang Thakkar</h3>
                                        <span>Member-Optometry</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Sr. Lecturer, Nagar School of Optometry, Ahmedabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_PURSHOTTAM_PUROHIT} className="img-fluid" alt="Shri Purshottam D. Purohit" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Shri Purshottam D. Purohit</h3>
                                        <span>Member-Occupational therapy</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Sr. Occupational therapist, Retired from Government Spine Institute, Civil Hospital, Ahmedabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_DEEPAK_GANJIWALE} className="img-fluid" alt="Dr. Deepak Ganjiwale" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. Deepak Ganjiwale</h3>
                                        <span>Member-Occupational therapy</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Occupational Therapy In Charge, Bhai Kaka University, K. M. Patel Institute of Physiotherapy, Anand</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_SL_VAYA} className="img-fluid" alt="Dr. S.L.Vaya" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. S.L.Vaya</h3>
                                        <span>Member-Behavioural Science</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Life Time Professor, Rastriya Raksha University, Gandhinagar</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_SUNIL_SHUKLA} className="img-fluid" alt="Dr. Sunil Shukla" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. Sunil Shukla</h3>
                                        <span>Member-Behavioural Science</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Director, Entrepreneurship Development Institute Of India(EDII), Gandhinagar</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_RAKESH_RAWAL} className="img-fluid" alt="Dr.Rakesh Rawal" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr.Rakesh Rawal</h3>
                                        <span>Member-Life Science</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Dean and Professor, Gujarat Biotechnology University, Gandhinagar</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_ALKA_SANGHVI} className="img-fluid" alt="Dr.Alka Sanghvi" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr.Alka Sanghvi</h3>
                                        <span>Member-Nutrition Science</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Visiting Faculty,Gujarat University, Ahmedabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <div className="members-details">
                                    <div className="members-image">
                                        <img src={Image_JJ_DHADUK} className="img-fluid" alt="Dr. J. J. Dhaduk" />
                                    </div>
                                    <div className="members-description">
                                        <h3>Dr. J. J. Dhaduk</h3>
                                        <span>Member-Nutrition Science</span>
                                        <div className="members-location">
                                            <img src={MapPin} className="img-fluid" alt="Map-Pin" />
                                            <p>Dean,Agricultural University, Banaskantha</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Members;
